import request from '@/utils/request'

// 分页查询单词
export function reqWordPage(params) {
    return request({
        url: '/education/word/page',
        method: 'post',
        data: params
    })
}

// 查询单词详情
export function reqWordDetail(id) {
    return request({
        url: '/education/word/detail',
        method: 'get',
        params: { id }
    })
}

// 新增单词
export function reqWordInsert(data) {
    return request({
        url: '/education/word/insert',
        method: 'post',
        data
    })
}

// 更新单词
export function reqWordUpdate(data) {
    return request({
        url: '/education/word/update',
        method: 'post',
        data
    })
}

// 删除单词
export function reqWordDelete(id) {
    return request({
        url: '/education/word/delete',
        method: 'get',
        params: { id }
    })
}

// 根据单元ID获取单词列表（用于级联下拉框）
export function reqWordListByUnit(unitId) {
    return request({
        url: '/education/word/listByUnit',
        method: 'get',
        params: { unitId }
    })
}

// 知识库资源树（年级→分册→单元），一次性加载，后端 Redis 缓存 5 天
export function reqResourceTree() {
    return request({
        url: '/education/word/tree',
        method: 'get'
    })
}

// 清除知识库资源树缓存
export function reqClearTreeCache() {
    return request({
        url: '/education/word/clearTreeCache',
        method: 'post'
    })
}

// 按单词名/中文释义模糊搜索
export function reqSearchWordByName(keyword) {
    return request({
        url: '/education/word/searchByName',
        method: 'get',
        params: { keyword }
    })
}

// 批量导入单词（按年级+分册，Excel 每个 sheet 对应一个单元）
export function reqBatchImportWords(formData) {
    return request({
        url: '/education/word/batchImport',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
